<template>
    <div class="body" >
        <!--        聊天框-->
        <div class="body_left"
            :style="{ width: `${initData.mainWidth}px`, height: `calc( ${initData.mainHeight}px - 33px )` }">
            <div :class="!initData.noticeMode ? 'visibilityhidden' : ''" class="notice">
                <span class="icon"></span>
                <div ref="notice" v-text="noticeText"></div>
            </div>
            <Chatpc></Chatpc>
            <quicklty></quicklty>
            <Footer></Footer>
        </div>
        <Modal v-if="this.$store.getters.getConfigPc.showModal"></Modal>
        <!--        侧边栏-->
        <Side></Side>
    </div>
</template>

<script>
import Footer from "./footer";
import Side from "./side";
import Chatpc from "./chatpc";
import Modal from "./modal";
import quicklty from "./quicklty";

export default {
    name: "bodypc",
    data() {
        return {
            showModal: false,
            noticeText: '',
        }
    },
    mounted() {


    },
    created() {

    },
    watch: {
        initData() {
            if (this.$store.state.initData.noticeMode && this.$store.state.initData.noticeMsg) {
                const div = document.createElement('div')
                div.innerHTML = this.$store.state.initData.noticeMsg
                this.noticeText = div.textContent || div.innerText;
                setTimeout(() => {
                    let time = parseInt(this.noticeText.length / 9).toFixed(0) || 15
                    if (time < 10) time = 15
                    if (!!this.$refs) {
                        this.$refs.notice.style.animationDuration = ` ${time}s `;
                    }
                }, 20)
            }
            return this.$store.state.initData
        },
    },
    computed: {
        initData() {

            return this.$store.state.initData
        },
    },
    components: {
        Footer,
        Chatpc,
        Side,
        Modal,
        quicklty
    }
}
</script>

<style scoped>
.body {
    flex: 1;
    display: flex;
    box-shadow: 0px 0px 3px #dcdcdc;
}

.body_left {
    flex: 1;
    width: 640px;
    position: relative;
    background: white;
    overflow: hidden;
}

.notice {
    padding: 6px 0;
    background: #fdf6d7;
    text-align: left;
    color: #563c3c;
    font-size: 13px;
    width: 100%;
    position: relative;
    line-height: 15px;
    overflow: hidden;
    border-left: 13px solid #fdf6d7;
}

.notice .icon {
    display: inline-block;
    background-color: #fdf6d7;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    background-size: 100% 100%;
    background-image: url("../../../static/image/notice.png");
    position: relative;
    z-index: 9;
}

.notice>div {
    display: inline-block;
    vertical-align: middle;
    white-space: nowrap;
    width: auto;
    position: absolute;
    animation: 18s move linear infinite normal;
    margin-top: 3px;
}

@keyframes move {
    0% {
        transform: translateX(600px);
        -webkit-transform: translateX(600px);
    }

    100% {
        transform: translateX(-100%);
        -webkit-transform: translateX(-100%);
    }
}

.notice p {
    margin: 2px;
}

.visibilityhidden {
    visibility: hidden;

}
</style>



// WEBPACK FOOTER //
// src/components/pc/body.vue